/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/15
 * Description: 文件描述
 */
import Vue from 'vue'
import store from './vuex'

Vue.directive('roleBtn',{
  bind:function (el,binding) {
    let roleArr = binding.value;
    let userRole = store.getters.rolenames;
    if (roleArr && roleArr.filter(x=>userRole.indexOf(x) > -1).length>0) {
      return false
    } else {
      el.parentNode.removeChild(el);
    }
  }
})
export default Vue






// WEBPACK FOOTER //
// ./src/btnPermission.js